import type { ComponentType, ReactNode } from 'react';
import { FacebookIcon } from './icons/FacebookIcon';
import { InstagramIcon } from './icons/InstagramIcon';
import { WebsiteIcon } from './icons/WebsiteIcon';
import { TikTokIcon } from './icons/TikTokIcon';
import { XIcon } from './icons/XIcon';
import type { OrganizerSocialLinks, OrganizerSocialPlatform } from '@/types/organizer';
import styles from './SocialLinks.module.scss';

const SOCIAL_ICONS: Record<OrganizerSocialPlatform, ComponentType> = {
  website: WebsiteIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  tiktok: TikTokIcon,
  x: XIcon,
};

interface Props {
  socials: OrganizerSocialLinks;
  children?: ReactNode;
}

export { styles as socialLinksStyles };

export function SocialLinks({ socials, children }: Props) {
  return (
    <div className={styles.socials}>
      {Object.keys(SOCIAL_ICONS).map((platform) => {
        const platformKey = platform as OrganizerSocialPlatform;
        const url = socials[platformKey]?.trim();
        if (!url) return null;
        const Icon = SOCIAL_ICONS[platformKey];
        return (
          <a
            key={platformKey}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialBtn}
          >
            <Icon />
          </a>
        );
      })}
      {children}
    </div>
  );
}
